import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});

async function fetchLevels(token, subject = null) {
  try {
    const response = await API.post("/levels", { token, subject });
    // const response = {
    //   data: [
    //     { id: 1, name: "EXPLORER" },
    //     { id: 2, name: "BEGINNER" },
    //     { id: 3, name: "LEARNER" },
    //     { id: 3, name: "THINKER" },
    //     { id: 3, name: "CHALLENGER" },
    //     { id: 3, name: "ACHIEVER" },
    //     { id: 3, name: "MASTER" },
    //     { id: 3, name: "GENIUS" },
    //   ],
    // };
    return response.data;
  } catch (error) {
    console.error("Error fetching subjects:", error);
    throw error;
  }
}

export { fetchLevels };
